import React, { Component } from "react";
export default class PopsMap extends Component {
  componentDidMount() {
    this.initMap();
    
  }

  initMap() {

    let options = {
        zoom: 2,
        center: new window.google.maps.LatLng(30, 10),
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,
	    styles: [{"featureType":"administrative.locality","elementType":"all","stylers":[{"hue":"#ff0200"},{"saturation":7},{"lightness":19},{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"labels.text","stylers":[{"visibility":"on"},{"saturation":"-3"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#748ca3"}]},{"featureType": "administrative","elementType": "geometry","stylers": [{ "visibility": "off" }]},{"featureType": "administrative.country","elementType": "geometry.stroke","stylers": [{"hue":"#ff0200"},{"saturation":4},{"lightness":10},{ "visibility": "on" }]},{"featureType": "administrative.province","elementType": "geometry.stroke","stylers": [{"hue":"#ff0200"},{"saturation":7},{"lightness":19},{ "visibility": "on" }]},{"featureType":"landscape","elementType":"all","stylers":[{"hue":"#ff0200"},{"saturation":-100},{"lightness":100},{"visibility":"simplified"}]},{"featureType":"poi","elementType":"all","stylers":[{"hue":"#ff0200"},{"saturation":"23"},{"lightness":"20"},{"visibility":"off"}]},{"featureType":"poi.school","elementType":"geometry.fill","stylers":[{"color":"#ffdbda"},{"saturation":"0"},{"visibility":"on"}]},{"featureType":"road","elementType":"geometry","stylers":[{"hue":"#ff0200"},{"saturation":"100"},{"lightness":31},{"visibility":"simplified"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#f39247"},{"saturation":"0"}]},{"featureType":"road","elementType":"labels","stylers":[{"hue":"#008eff"},{"saturation":-93},{"lightness":31},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#ffe5e5"},{"saturation":"0"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":-2},{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"hue":"#ff0200"},{"saturation":-90},{"lightness":-8},{"visibility":"simplified"}]},{"featureType":"transit","elementType":"all","stylers":[{"hue":"#e9ebed"},{"saturation":10},{"lightness":69},{"visibility":"on"}]},{"featureType":"water","elementType":"all","stylers":[{"hue":"#e9ebed"},{"saturation":-78},{"lightness":67},{"visibility":"simplified"}]}]

    };

    var locations = [
        ['Sydney', -33.868820, 151.209296],
     ['Brussels', 50.850346, 4.351721],
     ['Sao Paolo', -23.550520, -46.633309],
     ['Montreal', 45.501689, -73.567256],
     ['Hong Kong', 22.396428, 114.109497],
     ['Prague', 50.075538, 14.437800],
     ['Copenhagen', 55.676097, 12.568337],
     ['Helsinki', 60.169856, 24.938379],
     ['Villeurbanne', 45.771944, 4.890171],
     ['Berlin', 52.520007, 13.404954],
     ['Budapest', 47.497912, 19.040235],
     ['Pune', 18.520430, 73.856744],
     ['Bekasi', -6.238270, 106.975573],
     ['Dublin', 53.349805, -6.260310],
     ['Tokyo', 35.689487, 139.691706],
     ['Shakhtinsk', 49.717839, 72.584320],
     ['Cyberjaya', 2.921318, 101.655935],
     ['Amsterdam', 52.370216, 4.895168],
     ['Palmerston north', -40.352306, 175.608215],
     ['Gdansk', 54.352025, 18.646638],
     ['Warsaw', 52.229676, 21.012229],
     ['Lisbon', 38.722252, -9.139337],
     ['Saint petersburg', 59.934280, 30.335099],
     ['Moscow', 55.755826, 37.617300],
     ['Singapore', 1.352083, 103.819836],
     ['Barcelona', 41.385064, 2.173403],
     ['Goteborg', 57.708870, 11.974560],
     ['Zurich', 38.979222, -94.772516],
     ['Bangkok', 13.756331, 100.501765],
     ['Kiev', 50.450100, 30.523400],
     ['Maidenhead', 51.522414, -0.721900],
     ['Chicago', 41.878114, -87.629798],
     ['Seattle', 47.606209, -122.332071],
     ['Miami', 25.761680, -80.191790],
     ['Washington', 47.751074, -120.740139],
     ['Los angeles', 34.052234, -118.243685]
    
      ];
    
    // init map
    let map = new window.google.maps.Map(
      document.getElementById("map-cdn"),
      options
    );
    
    // map marker
    var infowindow = new window.google.maps.InfoWindow();
		  
    var marker, i;
  
    for (i = 0; i < locations.length; i++) {  
      marker = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(locations[i][1], locations[i][2]),
        map: map
      });
  
      window.google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          infowindow.setContent(locations[i][0]);
          infowindow.open(map, marker);
        }
      })(marker, i));
    }

  }

  render() 
  { 
    return <div id="map-cdn" />
  }
}